module.exports = __webpack_public_path__ + "img/Z71_01.e0cd428d.jpg";